import { Button, Modal, Text } from "../../../../components";
import React, { useImperativeHandle, useRef } from "react";
import Localization from "../../../../localization";
import EditRecipient from "./editRecipient";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import Recipient from "./recipients";

const Steps = ({}, ref) => {
  const { modifyDeviceAlarmRecipient, updateProgress, updateSubscription } =
    useViewModel();
  const ownerPermModalRef = useRef();

  const steps = {
    "1_1": {
      title: Localization.formatString(
        Localization.service.alarmSMS_steps_title,
        1
      ),
      children: (
        <Modal.Dialog
          description={Localization.service.alarmSMS_steps_1_1_desc}
          buttons={[
            {
              type: "primary",
              title: Localization.general.yes,
              onClick: () => {
                ownerPermModalRef.current.open({ step: "1_2" });
              },
            },
            {
              title: Localization.general.no,
              onClick: async () => {
                await updateProgress(Enums.serviceCardIDs.alarmSms, false);
                ownerPermModalRef.current.open({ step: "2_1" });
              },
            },
          ]}
        />
      ),
    },
    "1_2": {
      title: Localization.formatString(
        Localization.service.alarmSMS_steps_title,
        1
      ),
      children: (
        <EditRecipient
          isOwner
          onSave={async (data) => {
            await modifyDeviceAlarmRecipient({
              ...data,
              type: "sms",
              owner: true,
            });
            await updateProgress(Enums.serviceCardIDs.alarmSms, false);
            ownerPermModalRef.current.open({ step: "2_1" });
          }}
        />
      ),
    },
    "2_1": {
      title: Localization.formatString(
        Localization.service.alarmSMS_steps_title,
        2
      ),
      children: (
        <>
          <Text
            type="secondary"
            className="m-30-b"
            children={Localization.service.alarmSMS_steps_1_2_desc}
          />
          <Recipient canBeOwner={false} />
          <Button
            type="primary"
            className="m-30-t"
            title={Localization.general.done}
            onClick={() => ownerPermModalRef.current.close()}
          />
        </>
      ),
    },
  };

  useImperativeHandle(
    ref,
    () => ({ start: () => ownerPermModalRef.current.open({ step: "1_1" }) }),
    []
  );

  return (
    <Modal
      ref={ownerPermModalRef}
      child={(_) => steps[_.step]?.children ?? null}
      onClose={(_) => _.step === "2_1" && updateSubscription()}
      title={(data) => {
        const step = Localization.formatString(
          Localization.general.step_n_of_n,
          data.step.split("_")[0],
          2
        );
        return {
          children: [
            <Text
              size="inherit"
              lineHeight="inherit"
              className="d-none-mobile"
              children={`${Localization.general.activate_alarmSMS} - ${step}`}
            />,
            <Text
              size="inherit"
              className="d-none d-block-mobile"
              children={Localization.general.activate_alarmSMS}
            />,
            <Text
              level={5}
              weight={700}
              type="secondary"
              children={step}
              className="m-5-t d-none d-block-mobile"
            />,
          ],
        };
      }}
    />
  );
};

export default React.forwardRef(Steps);
